var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.8099 1.72057L7.65903 2.58223C7.47193 3.65079 6.35655 4.29043 5.33135 3.91709L4.50464 3.61603C4.10503 3.47051 3.65796 3.63155 3.44515 3.99767L1.11744 8.00233C0.904628 8.36845 0.98776 8.83356 1.31445 9.10454L1.99023 9.66511C2.82834 10.3603 2.82834 11.6396 1.99022 12.3349L1.31434 12.8955C0.987654 13.1665 0.904521 13.6316 1.11733 13.9977L3.44504 18.0024C3.65785 18.3685 4.10493 18.5295 4.50454 18.384L5.33135 18.0829C6.35655 17.7096 7.47193 18.3492 7.65903 19.4178L7.8099 20.2794C7.88283 20.6959 8.24677 21 8.67239 21H13.3278C13.7534 21 14.1174 20.6959 14.1903 20.2794L14.3412 19.4178C14.5283 18.3492 15.6437 17.7096 16.6689 18.0829L17.4955 18.384C17.8951 18.5295 18.3421 18.3685 18.555 18.0023L20.8827 13.9977C21.0955 13.6315 21.0123 13.1664 20.6857 12.8955L20.0098 12.3348C19.1717 11.6396 19.1717 10.3603 20.0098 9.66511L20.6856 9.10458C21.0122 8.83359 21.0954 8.36849 20.8826 8.00237L18.5549 3.99771C18.342 3.63159 17.895 3.47054 17.4954 3.61607L16.6689 3.91705C15.6437 4.29039 14.5283 3.65076 14.3412 2.5822L14.1903 1.72057C14.1174 1.30406 13.7534 1 13.3278 1H8.67239C8.24677 1 7.88283 1.30406 7.8099 1.72057ZM11.0001 14.913C13.1758 14.913 14.9396 13.1611 14.9396 11C14.9396 8.83889 13.1758 7.08696 11.0001 7.08696C8.82439 7.08696 7.06063 8.83889 7.06063 11C7.06063 13.1611 8.82439 14.913 11.0001 14.913Z",
    stroke: "currentColor",
    strokeOpacity: 0.8,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.1280d9a703e0645235330e11b71eaacc.svg";
export { ForwardRef as ReactComponent };